export const USE_MEDIA_QUEREY_VALUE = '(min-width: 480px)';
